import { useState, useRef, useEffect } from "react";
import {
  Button,
  Box,
  Typography,
  Backdrop,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import Step1 from "./Step1";
import Step2 from "./Step2";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addChallange } from "../../../api/addChallange";
import AgeConsentModal from "../../Modals/user/ageConsentModal/Modal";
import { useSkipFirstRender } from "../../../hooks/useSkipFirstRender";

const step1Fields = [
  "title",
  "category",
  "from_uk",
  "region",
  "club",
  "goal_scorer",
  "club_img",
  // "subCategory",
  // "childCategory",
  // "comments",
];

const step1editedfields = [
  "title",
  "category",
  "from_uk",
  "region",
  "club",
  "goal_scorer",
  "club_img",
  "subCategory",
  "childCategory",
];

const AddChallengeForm = ({ editGoalDetails }) => {
  const [next, setNext] = useState(false);
  const userData = useSelector((state) => state.user);
  const token = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);

  const [ageConsent, setAgeConsent] = useState(false);
  const [confirmAgeConsent, setConfirmAgeConsent] = useState(false);

  const formRef = useRef(null);

  let initialValues;
  if (editGoalDetails) {
    initialValues = {
      title: editGoalDetails?.[0]?.title || "",
      category: editGoalDetails?.[0]?.category || 1,
      from_uk: editGoalDetails?.[0]?.from_uk ? 1 : 0 || 1,
      region: editGoalDetails?.[0]?.region || "",
      club: editGoalDetails[0]?.club || "",
      videoFile: editGoalDetails?.[0]?.video_link || "",
      goal_scorer: editGoalDetails?.[0]?.goal_scorer || "",
      club_img: editGoalDetails?.[0]?.club_img || "",
      comments: editGoalDetails?.[0]?.comments || false, // 0 for false, 1 for true
      challenges: editGoalDetails?.[0]?.challenges || true, // 0 for false, 1 for true
      subCategory: editGoalDetails?.[0]?.gBGSubCategory || null,
      childCategory: editGoalDetails?.[0]?.sub_category || false,
    };
  } else {
    initialValues = {
      title: "",
      category: 1,
      subCategory: "",
      childCategory: "",
      from_uk: 1,
      region: "",
      club: "",
      videoFile: "",
      goal_scorer: "",
      club_img: "",
      comments: false, // 0 for false, 1 for true
    };
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      title: Yup.string().required("Title is required"),
      category: Yup.number().required("Category is required"),
      from_uk: Yup.number().required("Video From is required"),
      region: Yup.string().required("Region is required"),
      club: Yup.string().required("Club Name is required"),
      videoFile: Yup.mixed().required("Video is required"),
      goal_scorer: Yup.string().required("Challenger name is required"),
      club_img: Yup.mixed().required("Club Image is required"),
      subCategory: Yup.string()
        .nullable()
        .when("category", {
          // is: (value) => [1, 2, 3, 5, 6].includes(value),
          is: 6,
          then: (schema) => schema.required("Please select boys or girls"),

          otherwise: (schema) => {},
        }),
      childCategory: Yup.string()
        .nullable()
        .when("subCategory", {
          // is: (value) => [1, 2, 3, 5, 6].includes(value),
          is: (value) => value,
          then: (schema) =>
            schema.required("Please select age category for boys or girls"),

          otherwise: (schema) => {},
        }),
      // comments: Yup.number().test(
      //   "is boolean",
      //   "Enter the Boolean value",
      //   (value) => value === 0 || value === 1
      // ),
    }),
    validateOnChange: true,
    // validateOnBlur: true,
    onSubmit: async (values, { setSubmitting, resetForm }) => {

      const data = {
        title: values.title,
        category: values.category,
        from_uk: values.from_uk,
        region: values.region,
        club: values.club,
        videoFile: values.videoFile,
        user_id: userData.data.id,
        goal_scorer: values.goal_scorer,
        club_img: values.club_img,
        comments: values.comments,
        subCategory: values.childCategory,
      };

      // if (editGoalDetails) {
      //   "";
      //   "";

      // } else {
      try {
        setLoading(true);
        let resdata;
        if (editGoalDetails) {
          data.goal_id = editGoalDetails[0].id;
          resdata = await addChallange("editGoal", data, token);
        } else {
          resdata = await addChallange("addGoal", data, token);
        }
        // const resdata = await addGoal(data, token);
        if (resdata.success) {
          toast.success(resdata.message);
          setNext(false);
          navigate("/");
        } else {
          toast.error(resdata.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
      // }

      // if (!next) {
      //   setNext(true);
      // } else {
      //   // submit the form
      //   "";
      //   "";
      // }
    },
  });

  useSkipFirstRender(() => {
    if (formik.values.category == 6) {
      setAgeConsent(true);
    } else {
      setConfirmAgeConsent(false);
    }
  }, [formik.values.category]);

  useSkipFirstRender(() => {
    if (!confirmAgeConsent && formik.values.category == 6 && !ageConsent) {
      formik.setFieldValue("category", null);
    }
  }, [ageConsent]);

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
        // onClick={}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box className="addGoal-inner">
        <Box className="addGoal-header">
          {next ? (
            <Button
              sx={{
                alignItems: "center",
                gap: "5px",
                position: "unset !important",
              }}
              onClick={() => setNext(false)}
            >
              {" "}
              <KeyboardBackspaceIcon
                sx={{ color: "white", fontSize: { xs: "20px", md: "30px" } }}
              />
              <Typography component="h3">Back</Typography>{" "}
            </Button>
          ) : (
            <>
              <Button
                sx={{ alignItems: "center", gap: "5px" }}
                onClick={() => {
                  if (editGoalDetails) {
                    navigate("/myaccount/1");
                  } else {
                    navigate("/");
                  }
                }}
              >
                {" "}
                <KeyboardBackspaceIcon
                  sx={{
                    color: "white",
                    fontSize: { xs: "20px", md: "30px" },
                  }}
                />{" "}
                <Typography component="h3">Back</Typography>{" "}
              </Button>
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "start",
                }}
              >
                <Typography component="h1">
                  {editGoalDetails ? "Edit Challenge" : "Add Challenge"}
                </Typography>
              </Box>
            </>
          )}
        </Box>
        <form
          className="addGoal-form"
          onSubmit={formik.handleSubmit}
          ref={formRef}
        >
          {next ? (
            <>
              <Step2 formik={formik} edited={editGoalDetails ? true : false} />
              {submitted && (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.touched.videoFile || formik.errors.videoFile
                    ? formik.errors.videoFile
                    : ""}
                </FormHelperText>
              )}
            </>
          ) : (
            <Step1 formik={formik} edited={editGoalDetails ? true : false} />
          )}

          <Box className="btn-group" sx={{ width: "100%" }}>
            <Button
              variant="contained"
              className="btn"
              onClick={async () => {
                if (!next) {
                  if (!editGoalDetails) {
                    console.log(
                      formik.errors,
                      formik.values,
                    );
                    await formik.validateForm();
                    formik.handleSubmit();
                    console.log(
                      formik.errors,
                      formik.values,
                    );
                    const errorFields = [];

                    console.log(
                      step1Fields.some((field) => {
                        if (formik.errors[field] || !formik.touched[field]) {
                          errorFields.push(field);
                          return true;
                        } else {
                          return false;
                        }
                      }),
                    );

                    const error = step1Fields.some((field) => {
                      
                      if (formik.errors[field] || !formik.touched[field]) {
                        errorFields.push(field);
                        return true;
                      } else {
                        return false;
                      }
                    });
                    if (error) {
                      toast.error(
                        `Please fill all the required fields \n ${errorFields.join(
                          " , ",
                        )}`,
                      );
                      return;
                    }
                    setNext(true);
                  } else {
                    step1editedfields.map((field) => {
                      formik.setFieldTouched(field, true);
                    });
                    await formik.validateForm();
                    const errorFields = [];
                    const errorvalue = step1Fields.some((field) => {
                     
                      if (formik.errors[field]) {
                        errorFields.push(field);
                        return true;
                      } else {
                        return false;
                      }
                    });
                    if (errorvalue || Object.keys(formik.errors).length > 0) {
                      toast.error(
                        `Please fill all the required fields \n ${errorFields.join(
                          " , ",
                        )}`,
                      );
                      return;
                    }
                    setNext(true);
                  }
                } else {
                  if (formRef.current) {
                    setSubmitted(true);
                    formik.handleSubmit();
                  }
                }
              }}
            >
              {!next ? "Next" : editGoalDetails ? "Update" : "Publish"}
            </Button>
          </Box>
        </form>
      </Box>
      <AgeConsentModal
        open={ageConsent}
        setOpen={setAgeConsent}
        confirm={confirmAgeConsent}
        setConfirm={setConfirmAgeConsent}
      />
    </>
  );
};

export default AddChallengeForm;
